import { useState } from "react";
import { ChatCircleText, PaperPlaneRight, Sparkle } from "@phosphor-icons/react";

const SUGGESTIONS = [
  "What is my highest-yielding holding right now?",
  "Show me everything that needs attention this month.",
  "Estimate quarterly distributions from private funds.",
  "Which entities have annual renewals coming up?",
  "What's my net worth trend over the last 12 months?",
];

export default function AskMax() {
  const [draft, setDraft] = useState("");

  return (
    <div className="space-y-8 animate-fade-up">
      <div className="flex items-start gap-4 pb-6 border-b border-border">
        <div className="h-12 w-12 rounded-lg bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] flex items-center justify-center shadow-sm">
          <ChatCircleText size={22} weight="regular" />
        </div>
        <div>
          <p className="eyebrow">Operations</p>
          <h1 className="page-title text-[44px] sm:text-[52px] mt-1" data-testid="page-title">Ask Max</h1>
          <p className="text-sm text-muted-foreground mt-2 max-w-xl leading-relaxed">
            Your private family-office assistant. Ask anything about your holdings, statements, or upcoming obligations.
          </p>
        </div>
      </div>

      <div className="bg-card border border-border rounded-xl p-10 max-w-3xl mx-auto" data-testid="ask-max-panel">
        <div className="flex items-center gap-2 mb-2">
          <Sparkle size={14} className="text-[hsl(var(--primary))]" />
          <p className="eyebrow">Coming soon</p>
        </div>
        <h2 className="font-serif text-3xl tracking-tight leading-tight">
          Max is in training on your household's data.
        </h2>
        <p className="text-sm text-muted-foreground mt-3 leading-relaxed">
          When live, Max will reconcile bills, flag outliers, summarize statements, and answer plain-English questions about your portfolio — all without leaving this page.
        </p>

        <div className="mt-8">
          <p className="eyebrow mb-3">Try asking</p>
          <ul className="space-y-2">
            {SUGGESTIONS.map((s, i) => (
              <li key={i}>
                <button
                  data-testid={`ask-suggestion-${i}`}
                  onClick={() => setDraft(s)}
                  className="w-full text-left text-sm px-4 py-3 rounded-md bg-[hsl(36_30%_94%)] hover:bg-[hsl(36_30%_90%)] transition-colors"
                >“{s}”</button>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 relative">
          <input
            data-testid="ask-input"
            value={draft}
            onChange={(e) => setDraft(e.target.value)}
            placeholder="Type a question for Max…"
            disabled
            className="w-full pl-4 pr-12 py-3 rounded-lg border border-border bg-background text-sm disabled:opacity-70 disabled:cursor-not-allowed"
          />
          <button
            data-testid="ask-send"
            disabled
            className="absolute right-2 top-1/2 -translate-y-1/2 h-9 w-9 rounded-md bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] flex items-center justify-center opacity-50 cursor-not-allowed"
          >
            <PaperPlaneRight size={14} weight="fill" />
          </button>
        </div>
        <p className="text-[11px] text-muted-foreground mt-3 text-center">Disabled — Max is not yet wired to an LLM.</p>
      </div>
    </div>
  );
}
